/**
 * Created by zinia on 4/19/2020.
 */
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from '../actions/fx-rate.action';
import * as fromServices from '../../services/fx-rate-api.service';
import {catchError, map, mergeMap, switchMap} from 'rxjs/operators';
import {of, Observable} from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {TreeItemNode} from '@shared/models/tree-selector.models';
import {FxRateReportModel} from '../../models/fx-rate-report.model';

@Injectable()
export class FxRateEffect {
  constructor(private actions$: Actions,
              private commandService: CommandService,
              private fxRateService: fromServices.FxRateApiService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService ) {
    // console.info('Inside FxRateEffect');
  }



  getCurrencyTreeData$ = createEffect(() => this.actions$
    .pipe( ofType(fromActions.GET_CURRENCIES_TREE_DATA) )
    .pipe(
      mergeMap((action: fromActions.GetCurrenciesTreeDataAction) => {
        return this.fxRateService.getCurrenciesTreeData(action.reportId, action.currencyType)
          .pipe(
            map((payload: TreeItemNode[]) =>
              new fromActions.GetCurrenciesTreeDataSuccessAction(action.reportId, action.currencyType, payload)
            ),
            catchError( error => of(new fromActions.GetCurrenciesTreeDataFailedAction(error)))
          );
      })
    ));

  getCountryTreeData$ = createEffect(() => this.actions$
    .pipe( ofType(fromActions.GET_COUNTRIES_TREE_DATA) )
    .pipe(
      mergeMap((action: fromActions.GetCountriesTreeDataAction) => {
        return this.fxRateService.getCountriesTreeData(action.reportId, action.currencyType)
          .pipe(
            map((payload: TreeItemNode[]) =>
              new fromActions.GetCountriesTreeDataSuccessAction(action.reportId, action.currencyType, payload)
            ),
            catchError( error => of(new fromActions.GetCountriesTreeDataFailedAction(error)))
          );
      })
    ));

  getReportData$ = createEffect(() => this.actions$
    .pipe( ofType(fromActions.GET_FX_RATE_REPORT) )
    .pipe(
      mergeMap((action: fromActions.GetFxRateReportAction) => {
        return this.fxRateService.getFxRateReport(action.reportId)
          .pipe(
            map((payload: FxRateReportModel) =>
              new fromActions.GetFxRateReportSuccessAction(action.reportId, payload)
            ),
            catchError( error => of(new fromActions.GetFxRateReportFailedAction(error)))
          );
      })
    ));

}
